// setup-stage-manager.js

let stageState = {
  profilesCreated: false,
  foodsCreated: false,
};

export function setSetupStage(partialUpdate = {}) {
  stageState = { ...stageState, ...partialUpdate };
}

export function getSetupStage() {
  return { ...stageState };
}

export function isSetupComplete() {
  return stageState.profilesCreated && stageState.foodsCreated;
}

export function getNextSetupStage() {
  if (!stageState.profilesCreated) {
    console.log('[Setup] Next stage: Profiles');
    return 'profiles';
  }
  if (!stageState.foodsCreated) {
    console.log('[Setup] Next stage: Foods');
    return 'foods';
  }
  console.log('[Setup] All stages complete');
  return null; // setup complete
}

const STORAGE_KEY = 'samappSetupStageState';

export function persistSetupStage() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stageState));
}

export function restoreSetupStage() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) stageState = JSON.parse(stored);
}